const config = {
  requiredVersion: 22, //11
};

export default config;
